import { ServiceCourse } from "../types/models/service-course";
import { TaxiService } from "../types/records/taxi-service-record";

type ServiceMinimal = Pick<ServiceCourse, "priorite"> | null | undefined;

/**
 * Priorité du service minimal applicable à une réservation : celui du passager
 * s'il en a un, sinon celui de son entreprise, sinon Standard. Les services de
 * priorité inférieure ne lui sont pas dus.
 */
export const resolveMinimalPriorite = (
  passagerService: ServiceMinimal,
  entrepriseService: ServiceMinimal,
): number =>
  (passagerService ?? entrepriseService)?.priorite ?? TaxiService.Standard;
